import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FaGraduationCap, FaBook, FaUsers, FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const OgrenciDanismanligi = () => {
  const services = [
    {
      icon: <FaGraduationCap />,
      title: "Akademik Planlama",
      description: "Kişisel akademik hedef ve stratejilerin belirlenmesi"
    },
    {
      icon: <FaBook />,
      title: "Öğrenme Teknikleri",
      description: "Verimli çalışma ve öğrenme yöntemleri desteği"
    },
    {
      icon: <FaUsers />,
      title: "Sosyal Gelişim",
      description: "İletişim ve sosyal beceri geliştirme desteği"
    }
  ];

  return (
    <div className="min-h-screen bg-label">
      <Helmet>
        <title>Öğrenci Danışmanlığı – Sınav Kaygısı, Akademik Başarı ve Motivasyon</title>
        <meta name="description" content="Öğrenci Danışmanlığı ile akademik başarı, sınav kaygısı ve motivasyon yönetimi için profesyonel destek alın. Daha iyi öğrenme stratejileriyle başarınızı artırın." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yagmurdemiroz.com/ogrenci-danismanligi" />
        <meta property="og:title" content="Öğrenci Danışmanlığı - Akademik Başarı ve Motivasyon" />
        <meta property="og:description" content="Sınav kaygısı, akademik başarı ve motivasyon için profesyonel öğrenci danışmanlığı. Daha iyi öğrenme stratejileri ile başarılı ol." />
        <meta property="og:image" content="https://yagmurdemiroz.com/me.jpg" />
        <meta property="og:locale" content="tr_TR" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Service",
              "name": "Öğrenci Danışmanlığı",
              "description": "Akademik başarı ve kişisel gelişim için öğrenci danışmanlık hizmeti",
              "provider": {
                "@type": "Psychologist",
                "name": "Psikolog Yağmur Demiröz",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "İstanbul, Türkiye"
                },
                "telephone": "+90 544 135 47 54"
              }
            }
          `}
        </script>
      </Helmet>

      {/* Breadcrumb */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-2">
          <div className="flex items-center text-sm">
            <Link to="/" className="text-gray-600 hover:text-secondary">Ana Sayfa</Link>
            <FaChevronRight className="mx-2 text-gray-400" size={12} />
            <Link to="/calisma-alanlarim" className="text-gray-600 hover:text-secondary">Çalışma Alanlarım</Link>
            <FaChevronRight className="mx-2 text-gray-400" size={12} />
            <span className="text-secondary">Öğrenci Danışmanlığı</span>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-start">
          <div className="w-full md:w-2/3 mb-6 md:mb-0">
            <h1 className="text-4xl font-bold text-secondary mb-6">
              Öğrenci Danışmanlığı – Akademik Başarı ve Motivasyon Desteği
            </h1>
            
            <div className="prose max-w-none">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Öğrenci danışmanlığı hizmeti, akademik başarı ve kişisel gelişim hedeflerinize ulaşmanız için profesyonel destek sunar.
              </p>

              <h2 className="text-2xl font-semibold text-secondary mb-4">Danışmanlık Alanları</h2>
              <ul className="list-disc list-inside mb-6 text-gray-700">
                <li className="mb-2">Akademik başarı stratejileri</li>
                <li className="mb-2">Sınav kaygısı yönetimi</li>
                <li className="mb-2">Kariyer planlaması</li>
                <li className="mb-2">Zaman yönetimi becerileri</li>
              </ul>

              <div className="grid md:grid-cols-3 gap-6 my-8">
                {services.map((service, index) => (
                  <div key={index} className="bg-label p-6 rounded-lg border border-primary">
                    <div className="text-3xl text-secondary mb-4">{service.icon}</div>
                    <h3 className="text-xl font-semibold text-secondary mb-2">{service.title}</h3>
                    <p className="text-gray-600">{service.description}</p>
                  </div>
                ))}
              </div>

              <div className="space-y-6 mb-8">
                <div className="bg-label p-4 rounded-lg border border-primary">
                  <Link to="/moxo-testi" className="text-secondary hover:text-primary transition-colors">
                    Dikkat ve odaklanma alanlarında zorlanma gözlemlenmesi durumunda MOXO Testi ile değerlendirme yapılabilir.
                  </Link>
                </div>
                
                <div className="bg-label p-4 rounded-lg border border-primary">
                  <Link to="/oyun-terapisi" className="text-secondary hover:text-primary transition-colors">
                    Küçük yaş grubu öğrenciler için oyun terapisi, gelişimsel ve duygusal süreçleri destekleyici bir seçenek olarak değerlendirilebilir.
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/3 md:ml-8">
            <div className="sticky top-24 bg-white rounded-lg shadow-lg p-6">
              <h3 className="text-xl font-semibold text-secondary mb-4">
                Danışmanlık Randevusu
              </h3>
              <p className="text-gray-700 mb-6">
                Öğrenci danışmanlığı hizmeti hakkında detaylı bilgi almak ve randevu oluşturmak için iletişime geçebilirsiniz.
              </p>
              <a
                href="tel:+905441354754"
                className="w-full text-center inline-block bg-secondary text-label py-3 px-6 rounded-md hover:opacity-90 transition-all duration-300"
              >
                İletişime Geçin
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OgrenciDanismanligi;
